import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type AiCostLimitAlertsFetchFailedAction = {
	type: 'AI_COST_LIMIT_ALERTS_FETCH_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): AiCostLimitAlertsFetchFailedAction => ({
	type: 'AI_COST_LIMIT_ALERTS_FETCH_FAILED',
	payload,
});
